// Copyright (c) 2024 Goffy. This file belongs to Goffy. All Rights Reserved.

import FontAwesome from '@expo/vector-icons/FontAwesome';
import { useFonts } from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import { useEffect } from 'react';

import { I18nProvider } from '@/i18n';
import { UserProvider } from './user-context';
import { AppErrorBoundary } from '@/components/AppErrorBoundary';
import RootLayoutNav from '@/app/layout/RootLayoutNav';

export const ErrorBoundary = AppErrorBoundary;

export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'login',
};

// Prevent the splash screen from auto-hiding before asset loading is complete.
SplashScreen.preventAutoHideAsync();

export default function RootLayout() {
  const [loaded, error] = useFonts({
    SpaceMono: require('../assets/fonts/SpaceMono-Regular.ttf'),
    Playball: require('../assets/fonts/Playball-Regular.ttf'),
    Sanchez: require('../assets/fonts/Sanchez-Regular.ttf'),
    ...FontAwesome.font,
  });

  // Expo Router uses Error Boundaries to catch errors in the navigation tree.
  useEffect(() => {
    if (error) throw error;
  }, [error]);

  useEffect(() => {
    if (loaded) {
      SplashScreen.hideAsync();
    }
  }, [loaded]);

  if (!loaded) {
    return null;
  }

  return (
    <AppErrorBoundary>
      <I18nProvider>
        <UserProvider>
          <RootLayoutNav />
        </UserProvider>
      </I18nProvider>
    </AppErrorBoundary>
  );
}
